import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostBinding,
  inject,
  Input,
  OnChanges,
  PLATFORM_ID,
} from '@angular/core';
import SwiperCore, { Swiper } from 'swiper';
import {
  Autoplay,
  EffectCoverflow,
  Navigation,
  Pagination,
} from 'swiper/modules';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, isPlatformBrowser } from '@angular/common';

SwiperCore.use([Autoplay, Navigation, Pagination, EffectCoverflow]);

@Component({
  selector: 'app-carousel-navigation',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './carousel-navigation.component.html',
  styleUrls: ['./carousel-navigation.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarouselNavigationComponent implements OnChanges {
  @Input() swiperInstance!: Swiper;

  public isBeginning = true;
  public isEnd = false;
  public showNavigation = true;
  private platformId = inject(PLATFORM_ID);


  @HostBinding('class') @Input() class = '';

  constructor() { }

  ngOnChanges(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initSwiper();
    }
  }

  initSwiper() {
    if (this.swiperInstance) {
      // Listen to Swiper events
      this.swiperInstance.on('slideChange', () => this.updateNavigationState());
      this.swiperInstance.on('reachEnd', () => (this.isEnd = true));
      this.swiperInstance.on('reachBeginning', () => (this.isBeginning = true));

      // Check if the swiper is locked
      this.swiperInstance.on('lock', () => this.updateNavigationVisibility());
      this.swiperInstance.on('unlock', () => this.updateNavigationVisibility());

      // Initial visibility check
      this.updateNavigationVisibility();
    }
  }

  updateNavigationState() {
    if (this.swiperInstance) {
      this.isBeginning = this.swiperInstance.isBeginning;
      this.isEnd = this.swiperInstance.isEnd;
    }
  }

  updateNavigationVisibility() {
    if (this.swiperInstance) {
      // The swiper will be locked if there are not enough slides to scroll
      this.showNavigation = !this.swiperInstance.isLocked;
    }
  }

  navigateSlide(direction: 'next' | 'prev') {
    if (this.swiperInstance) {
      if (direction === 'next') {
        this.swiperInstance.slideNext();
      } else {
        this.swiperInstance.slidePrev();
      }
    }
  }
}
